document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-purchase-form]').forEach((form) => {
    const variantInput = form.querySelector('[data-variant-input]');
    const sellingPlanInput = form.querySelector('[data-selling-plan-input]');
    const submitButton = form.querySelector('[data-purchase-submit]');
    const options = form.querySelectorAll('[data-purchase-option]');

    options.forEach((option) => {
      option.addEventListener('change', () => {
        form.querySelectorAll('.purchase-option').forEach((label) => label.classList.remove('is-selected'));
        option.closest('.purchase-option')?.classList.add('is-selected');
        variantInput.value = option.dataset.variantId;
        const available = option.dataset.available === 'true';
        if (submitButton) {
          submitButton.disabled = !available;
          submitButton.textContent = available ? 'Quiero descubrirlos' : 'Agotado';
        }

        if (option.dataset.sellingPlan) {
          sellingPlanInput.disabled = false;
          sellingPlanInput.value = option.dataset.sellingPlan;
        } else {
          sellingPlanInput.disabled = true;
          sellingPlanInput.value = '';
        }
      });
    });
  });

  const submissionStorageKey = 'cafaithPendingContactForm';
  document.querySelectorAll('[data-cafaith-contact-form]').forEach((form) => {
    form.addEventListener('submit', () => {
      try {
        window.sessionStorage.setItem(submissionStorageKey, JSON.stringify({
          type: form.dataset.cafaithContactForm,
          createdAt: Date.now()
        }));
      } catch (error) {
        // Shopify's return URL remains available if browser storage is restricted.
      }
    });
  });

  const successPopups = Array.from(document.querySelectorAll('[data-success-popup]'));
  if (successPopups.length) {
    const params = new URLSearchParams(window.location.search);
    const requestedPopup = params.get('cafaith_form');
    const serverConfirmedPopup = successPopups.find((item) => item.dataset.serverConfirmed === 'true');
    let pendingSubmission;

    try {
      pendingSubmission = JSON.parse(window.sessionStorage.getItem(submissionStorageKey) || 'null');
    } catch (error) {
      pendingSubmission = null;
    }

    const pendingIsRecent = pendingSubmission
      && ['waitlist', 'roaster'].includes(pendingSubmission.type)
      && Date.now() - pendingSubmission.createdAt < 30 * 60 * 1000;
    const navigationType = window.performance.getEntriesByType('navigation')[0]?.type;
    const hasFormErrors = Boolean(document.querySelector('.form-errors'));
    const pendingCanOpen = pendingIsRecent && navigationType !== 'back_forward' && !hasFormErrors;
    const popupType = serverConfirmedPopup?.dataset.successPopup
      || requestedPopup
      || (pendingCanOpen ? pendingSubmission.type : '');
    const popup = successPopups.find((item) => item.dataset.successPopup === popupType);

    if (popup) {

    const closeButtons = popup.querySelectorAll('[data-success-popup-close]');
    const closeButton = popup.querySelector('.success-popup__close');

    try {
      window.sessionStorage.removeItem(submissionStorageKey);
    } catch (error) {
      // No action is required when browser storage is restricted.
    }

    const closePopup = () => {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('has-success-popup');

      const cleanUrl = new URL(window.location.href);
      cleanUrl.searchParams.delete('cafaith_form');
      cleanUrl.searchParams.delete('contact_posted');
      window.history.replaceState({}, '', `${cleanUrl.pathname}${cleanUrl.search}${cleanUrl.hash}`);
    };

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('has-success-popup');
    window.requestAnimationFrame(() => closeButton?.focus());

    closeButtons.forEach((button) => button.addEventListener('click', closePopup));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !popup.hidden) closePopup();
    });
    }
  }

  document.querySelectorAll('[data-menu-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const menu = document.querySelector('[data-mobile-menu]');
      const open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      menu?.toggleAttribute('hidden', open);
    });
  });
});
